// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"020ce4d0","453":"ecb89657","455":"57cb6102","977":"ababe9ba"}[chunkId] + ".chunk.js";
};